<div [innerHTML]="jsonLdScript"></div>
